import React from 'react';

import { Container, Content, Title, Details } from './styles';

interface Props {
  title?: string | JSX.Element[];
  details?: string | JSX.Element[];
  detailsOptional?: string;
  joinContent?: boolean;
  noGap?: boolean;
  children?: any;
  hide?: boolean;
}

const Section = ({ title, details, detailsOptional, joinContent, noGap, children, hide }: Props) => {
  if (hide)
    return <></>;
  
  
  return (<Container>
    <div>
      {title && <Title>{title}</Title>}
      {details && <Details>{details}</Details>}
      {detailsOptional && <Details>{detailsOptional}</Details>}
    </div>
    <Content noGap={noGap} joinContent={joinContent}>
      {children}
    </Content>
  </Container>
)}
;

export default Section;
